import { useTranslation } from '@multaqa/i18n'
import { Label } from '@multaqa/ui/components/ui/label'
import { RadioGroup, RadioGroupItem } from '@multaqa/ui/components/ui/radio-group'
import type { WorkflowMode } from './workflow-levels'

/** The two ways a path decides, each explained in one line (ADR-0034). */
export function WorkflowModeField({
  mode,
  onChange,
}: {
  mode: WorkflowMode
  onChange: (mode: WorkflowMode) => void
}) {
  const { t } = useTranslation('workflow')

  return (
    <fieldset className="grid gap-2">
      <legend className="mb-1 text-small font-medium">{t('mode.label')}</legend>
      <RadioGroup
        value={mode}
        onValueChange={(value) => onChange(value as WorkflowMode)}
        className="grid gap-2 sm:grid-cols-2"
      >
        {(['escalation', 'chain'] as const).map((option) => (
          <Label
            key={option}
            htmlFor={`workflow-mode-${option}`}
            className="flex cursor-pointer items-start gap-2 border border-border p-3 font-normal has-[[data-state=checked]]:border-brand"
          >
            <RadioGroupItem id={`workflow-mode-${option}`} value={option} className="mt-0.5" />
            <span className="grid gap-0.5">
              <span className="text-body font-medium">{t(`mode.${option}.title`)}</span>
              <span className="text-small text-muted-foreground">
                {t(`mode.${option}.description`)}
              </span>
            </span>
          </Label>
        ))}
      </RadioGroup>
    </fieldset>
  )
}
